import { render, staticRenderFns } from "./ai-image-button.vue?vue&type=template&id=6a7ff9d4&lang=html"
import script from "./ai-image-button.vue?vue&type=script&lang=js"
export * from "./ai-image-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports